import Hero from "@/components/Hero";
import Activites from "@/components/Activites";
import Secteurs from "@/components/Secteurs";
import SolutionsDigitales from "@/components/SolutionsDigitales";
import Approche from "@/components/Approche";
import Modes from "@/components/Modes";
import Expertise from "@/components/Expertise";
import International from "@/components/International";
import ContactSection from "@/components/ContactSection";

export default function Home({ t }) {
  return (
    <>
      <Hero t={t} />
      <Activites t={t} />
      <Secteurs t={t} />
      <SolutionsDigitales t={t} />
      <Approche t={t} />
      <Modes t={t} />
      <Expertise t={t} />
      <International t={t} />
      <ContactSection t={t} />
    </>
  );
}
